<script setup lang="ts">
import { stringToFaDateTime } from '@payjib/shared'
import { computed, ref } from 'vue'
import { getReleasesAction } from '@/api/functions/release/get-releases-action'
import { useQueryApi } from '@/composables/useApi'
import { useToast } from '@/composables/useToast'
import { getErrorMessage } from '@/utils/errorUtils'

const toast = useToast()

const tabs = [{ title: 'بروزرسانی ها', link: '/releases' }]

const columns = [
  { key: 'id', label: '#', class: 'col-span-1 text-sm font-fa' },
  { key: 'version', label: 'ورژن', class: 'col-span-2 text-sm font-fa' },
  { key: 'created_at', label: 'تاریخ', class: 'col-span-2 text-sm font-fa' },
  { key: 'title', label: 'شرح بروزرسانی ها', class: 'col-span-7 text-sm' },
]

const currentPage = ref(1)

const { data: releasesData, isLoading } = useQueryApi({
  queryKey: computed(() => ['releases', currentPage.value]),
  queryFn: async () => {
    try {
      const response = await getReleasesAction()
      return response?.data || []
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: unknown) {
      toast.error(getErrorMessage(err) || 'خطا در دریافت بروزرسانی ها')
      return []
    }
  },
  // keepPreviousData: true,

  staleTime: 1000 * 60 * 3,
})

const rows = computed(() => {
  const items = releasesData.value || []
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return items.map((r: any) => ({
    id: r.id,
    version: r.version,
    created_at: stringToFaDateTime(r.createdAt),
    title: r.description,
  }))
})
</script>


<template>
    <div class="w-full mb-12">
        <div class="w-full">
            <h2 class="text-[22px] text-[#1b325a ] mb-7">بروزرسانی فنی</h2>
            <!-- Tabs  -->
            <Tabs :tabs="tabs" :isAdminPanel="true" class="mt-8" />
        </div>

        <div class="mt-8">
            <Table :columns="columns" :rows="rows" :isLoading="isLoading" />
        </div>
    </div>
</template>
